module.exports = __webpack_public_path__ + "static/img/dataRetrievalBg.6abf247b.png";